export enum ENVIRONMENT {
  LOCAL = 'local',
  DEVELOPMENT = 'dev',
  PRODUCTION = 'production',
  QA = 'qa'
}

export interface BaseAppConfig {
  apiUrl: string
  environment: ENVIRONMENT
}

export interface AppConfig extends BaseAppConfig {
  variables: ApiConfigResponse
}

export type ApiConfigResponse = {
  AMPLITUDE_API_KEY: string
  BRANCH_API_KEY: string
  SOCURE_PUBLIC_KEY: string
  promotionOverrides?: PromotionOverrides[]
}

export type PromotionOverrides = {
  _id: string
  name: string
  colors: PromotionColor
  typography: PromotionTypography
  offerDetails: PromotionOfferDetail
  assets: AssetUrl
}

export type PromotionColor = {
  backgroundGradient: string
  main: string
}

export type PromotionTypography = {
  bannerHeader: string
  landingHeader: string
  legalNote1: string
}

export type AssetUrl = {
  heroUrl: string
  logoUrl: string
}

export type PromotionOfferDetail = {
  amfWavier: boolean
  offerPercentages: OfferPerenctageValue
}

export type OfferPerenctageValue = {
  healthWellnessCashback: number
  otherCashback: number
  partnerCashback: number
}

export const WEB_DOMAIN_URL_MAP = new Map<string, string>([
  [ENVIRONMENT.LOCAL, 'localhost'],
  [ENVIRONMENT.DEVELOPMENT, 'apply.dev.paceline.fit'],
  [ENVIRONMENT.PRODUCTION, 'apply.paceline.fit'],
  [ENVIRONMENT.QA, 'apply.qa.paceline.fit']
])

export const API_BASE_URL = {
  [ENVIRONMENT.LOCAL]: { baseUrl: 'api.dev.paceline.fit', stage: 'dev' },
  [ENVIRONMENT.DEVELOPMENT]: { baseUrl: 'api.dev.paceline.fit', stage: 'dev' },
  [ENVIRONMENT.PRODUCTION]: { baseUrl: 'v1.ios-api.paceline.fit', stage: 'v1' },
  [ENVIRONMENT.QA]: { baseUrl: 'qa.ios-api.paceline.fit', stage: 'qa' }
}

export const APP_ID = 'cc_apply_app'
export const VERSION = 'latest'
